var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "apple__c",
    x1: 0,
    x2: 0,
    y1: 0,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F452FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#832BC1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "apple__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#apple__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "apple__b",
    width: 32,
    height: 32,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0c12.357 0 16 3.643 16 16s-3.643 16-16 16S0 28.357 0 16 3.643 0 16 0Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#apple__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#apple__c)",
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M15.967 3.537a11.333 11.333 0 0 0-3.718 22.027.153.153 0 0 0 .202-.166 58.705 58.705 0 0 1-.164-1.161.388.388 0 0 0-.229-.307 9.884 9.884 0 1 1 7.885 0 .388.388 0 0 0-.229.307c-.05.383-.105.773-.164 1.16a.152.152 0 0 0 .202.165 11.332 11.332 0 0 0-3.785-22.025ZM16 16.583a2.638 2.638 0 1 1 0-5.276 2.638 2.638 0 0 1 0 5.276Zm-.004 1.068a3.23 3.23 0 0 1 2.335.838c.25.248.402.578.43.928.063.813.045 1.63-.054 2.438a55.305 55.305 0 0 1-.452 3.647c-.084.62-.21 1.235-.378 1.84a1.823 1.823 0 0 1-1.881 1.12 1.824 1.824 0 0 1-1.881-1.12 13.97 13.97 0 0 1-.379-1.84 55.556 55.556 0 0 1-.452-3.647 12.04 12.04 0 0 1-.052-2.438c.028-.35.18-.679.428-.928a3.224 3.224 0 0 1 2.336-.838Zm5.673-5.15a6.14 6.14 0 0 0-5.908-3.764 6.14 6.14 0 0 0-3.96 10.614.47.47 0 0 1 .148.369c-.022.431-.018.864.013 1.295a.149.149 0 0 1-.232.132 7.591 7.591 0 1 1 8.546-.001.15.15 0 0 1-.233-.133c.029-.43.033-.862.013-1.294a.474.474 0 0 1 .148-.368 6.139 6.139 0 0 0 1.465-6.85Z",
    clipRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.7d67a12199bd30064f9e123e6855ef4a.svg";
export { ForwardRef as ReactComponent };